import { ChatBot } from "./types";

export const ZORINTHA: ChatBot = {
  id: "001",
  name: "Zorintha",
  systemRole: "assistant",
  systemPrompt: "A general purpose language learning tutor",
};
